"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ParagraphEightContent = void 0;
const lib_1 = require("@brandfree-front/lib");
const react_1 = __importDefault(require("react"));
const RootStore_1 = require("../../../stores/RootStore");
const ParagraphEightContent = () => {
    const { translate } = react_1.default.useContext(RootStore_1.RootStoreContext).translateStore;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.eight.text1')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.eight.text2')),
        react_1.default.createElement("p", null, translate('gdpr.privacy.notification.paragraph.eight.text3')),
        react_1.default.createElement("p", null,
            translate('gdpr.privacy.notification.paragraph.eight.text4'),
            react_1.default.createElement(lib_1.Anchor, { url: "https://www.teliacompany.com/en/category/privacy-and-security" }, translate('gdpr.privacy.notification.paragraph.eight.link')),
            ".")));
};
exports.ParagraphEightContent = ParagraphEightContent;
